import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountRouterManager } from '../../controller/router-handler';
import { accountInfoModel } from '../../models/serviceResponse.model';
import { AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from '../../module-config/module-config';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  accountInfo!: accountInfoModel;

  private accountRouter = new AccountRouterManager(this.router);

  constructor(private router: Router, @Inject(ACCOUNT_DISPLAY_CONFIG) private accountRouterConfig: AccountModuleDisplayConfig) {
    
    this.accountRouter.setRouterConfig(accountRouterConfig.displayAreaConfig);
    
    if(this.router.getCurrentNavigation()?.extras.state && this.router.getCurrentNavigation()?.extras.state?.accountInfo){
      this.accountInfo = this.router.getCurrentNavigation()?.extras.state?.accountInfo;
    }
    else{
      this.accountRouter.toMyAccount();
    }
  }

  ngOnInit(): void {
  }

  changeName(){
    this.accountRouter.toChangeProfile(this.accountInfo);
  }

  changePin(){
    this.accountRouter.toChangePin();
  }

  changeEmail(){
    this.accountRouter.toChangeEmail(this.accountInfo);
  }

  changePhoneNumber(){
    this.accountRouter.toChangePhoneNumber(this.accountInfo);
  }
  
}
